export const calculatePromoDates = _ref => {
  let {
    startDate,
    endDate
  } = _ref;
  return {
    start: new Date(`${startDate}T00:00:00`).getTime(),
    end: new Date(`${endDate}T23:59:59`).getTime()
  };
};